import TopNav from "../components/TopNav.jsx";
import ProductMark from "../components/ProductMark.jsx";
import FreeConsultWidget from "../components/FreeConsultWidget.jsx";

/**
 * AlmonerPage · /almoner
 * Free forever · non-profit consult · the Deloitte non-profit-arm door,
 * dropped to zero.
 */
export default function AlmonerPage() {
  return (
    <div className="min-h-screen bg-sage-bg text-sage-text sage-grain" data-testid="almoner-page">
      <TopNav />
      <div className="mx-auto max-w-4xl px-4 md:px-8 py-12">
        <div className="text-[10px] uppercase tracking-[0.3em] text-sage-accent mb-3">FREE FOREVER · CHARITABLE-GIVING TIER</div>
        <div className="flex items-start gap-4 mb-4">
          <div className="text-sage-accent shrink-0"><ProductMark slug="almoner" size={48} /></div>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tighter uppercase">Almoner</h1>
        </div>
        <p className="text-lg text-sage-muted leading-relaxed max-w-3xl mb-10 sage-prose">
          The charitable-giving engine. Free forever. The same strategic consult a large firm charges families and foundations six figures for — plain-english, no sales pitch, no assets-under-management skim. Sage helps you give money in a way that actually works.
        </p>

        <div className="border border-sage-border p-6 mb-10">
          <div className="text-xs uppercase tracking-[0.15em] text-sage-muted mb-3">Who it's for</div>
          <ul className="list-disc list-inside text-sm text-sage-text space-y-2 sage-prose">
            <li>Donors who want their money to shrink a problem, not fund a brochure</li>
            <li>Family foundations without a paid consultant</li>
            <li>People giving their first meaningful check and wanting it to land</li>
            <li>Estate-planners looking for real charitable-vehicle guidance without the pitch</li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-10">
          <div className="border border-sage-border p-4" data-testid="almoner-feature-1">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Cause research</div>
            <div className="text-xs text-sage-muted sage-prose">Which organizations actually move the needle for a given problem — sourced from public 990s and third-party evaluators (Charity Navigator, GiveWell, ProPublica Nonprofit Explorer).</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="almoner-feature-2">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Giving vehicle guide</div>
            <div className="text-xs text-sage-muted sage-prose">Direct gift vs DAF vs private foundation vs charitable trust — trade-offs in plain english.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="almoner-feature-3">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Grant sizing</div>
            <div className="text-xs text-sage-muted sage-prose">How much is meaningful without swamping a small non-profit's capacity.</div>
          </div>
          <div className="border border-sage-border p-4" data-testid="almoner-feature-4">
            <div className="text-sm font-bold uppercase tracking-tight text-sage-text mb-1">Two-test screen</div>
            <div className="text-xs text-sage-muted sage-prose">Every recommendation is filtered by Sage's self-shrinking rule: does the money help the person, AND does it shrink the population that needs it.</div>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="text-2xl font-bold uppercase tracking-tight text-sage-text mb-3">Ask Almoner — anonymous</h2>
          <FreeConsultWidget
            role="almoner-charitable-giving"
            productSlug="almoner"
            placeholder="Describe what you want to give to (a cause, a region, a specific problem) and roughly how much. Sage will map the field."
            ctaLabel="Ask Almoner"
            disclaimer="Almoner is a strategic helper, not a licensed financial advisor. It does not custody money or execute grants. It gives you the map so you can act."
          />
        </div>

        <div className="border-t border-sage-border pt-6 text-xs text-sage-muted sage-prose">
          Almoner charges no fee, keeps no percent, holds no AUM. The paid consultancy industry runs 1–2% of assets under management on this same service — that layer costs the philanthropic world an estimated $10B a year. Almoner puts it at zero.
        </div>
      </div>
    </div>
  );
}
